<!--通用确认弹窗 -->
<template>
  <div v-if="display" v-modal-show="display">
    <div @click="closeModal()" class="mask"></div>
      <section class="M_wrap M_info M_btn_1">
        <p class="M_title T_18_25 T_b">{{ modalTitle }}</p>
        <div class="M_cont" v-html="content">
        </div>
        <div class="M_btns cf">
          <a href="javascript:void(0);" @click="confirm()" :class="'M_btn T_w ' + $style.cssBtnColor" >{{ modalConfirm }}</a>
        </div>
        <a class="M_close I_n" @click="closeModal()"></a> 
      </section>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        display: false
      }
    },
    mounted () {
      let _this = this
      setTimeout(function () {
        _this.display = _this.showModal
      }, 10)
    },
    props: {
      showModal: {
        type: Boolean,
        required: false
      },
      content: {
        type: String,
        required: true
      },
      confirmText: {
        type: String
      },
      title: {
        type: String
      },
      confirmCallback: {
        type: Function,
        required: false
      },
      closeCallback: {
        type: Function,
        required: false
      }
    },
    computed: {
      modalConfirm () {
        if (this.confirmText !== undefined && this.confirmText !== '') {
          return this.confirmText
        } else {
          return '确认'
        }
      },
      modalTitle () {
        if (this.title !== undefined && this.title !== '') {
          return this.title
        } else {
          return '提示'
        }
      }
    },
    methods: {
      show: function () {
        this.display = true
      },
      confirm: function () {
        this.display = false
        this.$emit('confirm')
        if (this.confirmCallback) {
          this.confirmCallback()
        }
      },
      closeModal: function () {
        this.display = false
        this.$emit('closeModal')
        if (this.closeCallback) {
          this.closeCallback()
        }
      }
    }
  }
</script>

<style scoped src="@v2/assets/css/modals.module.css"></style>


// WEBPACK FOOTER //
// ConfirmModal.vue?f2f30300